/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyHealthcheckItem } from "./ShopifyHealthcheckItem";
import {
  ShopifyHealthcheckItemFromJSON,
  ShopifyHealthcheckItemFromJSONTyped,
  ShopifyHealthcheckItemToJSON,
  ShopifyHealthcheckItemToJSONTyped,
} from "./ShopifyHealthcheckItem";

/**
 *
 * @export
 * @interface ShopifyHealthcheckResult
 */
export interface ShopifyHealthcheckResult {
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckResult
   */
  shopDomain?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckResult
   */
  linkState: string;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyHealthcheckResult
   */
  ok: boolean;
  /**
   *
   * @type {Array<ShopifyHealthcheckItem>}
   * @memberof ShopifyHealthcheckResult
   */
  items: Array<ShopifyHealthcheckItem>;
}

/**
 * Check if a given object implements the ShopifyHealthcheckResult interface.
 */
export function instanceOfShopifyHealthcheckResult(
  value: object,
): value is ShopifyHealthcheckResult {
  if (!("linkState" in value) || value["linkState"] === undefined) return false;
  if (!("ok" in value) || value["ok"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function ShopifyHealthcheckResultFromJSON(
  json: any,
): ShopifyHealthcheckResult {
  return ShopifyHealthcheckResultFromJSONTyped(json, false);
}

export function ShopifyHealthcheckResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyHealthcheckResult {
  if (json == null) {
    return json;
  }
  return {
    shopDomain: json["shopDomain"] == null ? undefined : json["shopDomain"],
    linkState: json["linkState"],
    ok: json["ok"],
    items: (json["items"] as Array<any>).map(ShopifyHealthcheckItemFromJSON),
  };
}

export function ShopifyHealthcheckResultToJSON(
  json: any,
): ShopifyHealthcheckResult {
  return ShopifyHealthcheckResultToJSONTyped(json, false);
}

export function ShopifyHealthcheckResultToJSONTyped(
  value?: ShopifyHealthcheckResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shopDomain: value["shopDomain"],
    linkState: value["linkState"],
    ok: value["ok"],
    items: (value["items"] as Array<any>).map(ShopifyHealthcheckItemToJSON),
  };
}
